import styled from "styled-components";

import { CircleColorPropsInterface, RadioButtonInterface } from "./interfaces";

import colors from "../../assets/css/colors";

export const Main = styled.div`
    width: 75%;

    @media (max-width: 1024px){
        width: 100%;
    }
`;

export const CardDetailsFutureValue = styled.div`
    background-color: ${colors.grayLight};
    border-radius: 27px;
    padding: 20px 32px;
    text-align: center;
    width: 250px;
    margin-right: 20px;
    @media( max-width:690px ) {
        margin-bottom: 20px;
    }

` 

export const CircleStatus = styled.div`
    width: 8px;
    height: 8px;
    margin-right: 3px;
    border-radius: 4px;
    margin-top: 2px;
    background-color: ${(p: CircleColorPropsInterface) => p.color};
`;

export const DetailsButton = styled.div`
    width: 72px;
    height: 17px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: none;
    background: transparent 0% 0% no-repeat padding-box;
    border: 1px solid ${colors.primary};
    border-radius: 4px;
    color: ${colors.primary};
    font: normal normal 600 8px Muli;
    cursor: pointer;

    &:hover{
        background-color: ${colors.primary};
        color: ${colors.white};
    }

    &:focus{
        outline: 0;
    }
`

export const BalanceContainer = styled.div`
    display: flex;
    justify-content: space-between;

    @media (max-width: 1160px){
        display: block
    }
`;

export const DashboardBalanceBoxContainer = styled.div`
    width: 336px;

    @media (max-width: 1160px){
        width: 100%;
    }
`;

export const TransferContainer = styled.div`
    display: flex;
    margin-bottom: 35px;

    @media (max-width: 500px) {
        display: block;
    }
`

export const TransferBalance = styled.div`
    padding-right: 30px;
    margin-right: 24px;
    border-right: 1px solid ${colors.grayLight};

    @media (max-width: 500px){
        margin-bottom: 20px;
    }
`

export const BalanceCurrecy = styled.span`
    font: normal normal 300 15px Muli;
    color: ${colors.primary};
`;

export const BalanceValue = styled.span`
    font: normal normal 600 20px Muli;
    color: ${colors.primary};
`;

export const FormAndTransferContainerFlex = styled.div`
    display: flex;
    flex-grow: 1;
`;

export const FormInput = styled.div`
    display: flex;

    @media (max-width: 775px){
        display: block;
    }
`

export const BankAccountAndSelectAnotherContainer = styled.div`
    display: flex;
    
    @media (max-width: 500px){
        display: block;
    }
`

export const TableTitle = styled.h2`
    font: normal normal normal 16px Circular Std Book;
    color: ${colors.tertiary};
    margin-top: 45px;
`;

export const Title = styled.h2`
    font: normal normal normal 16px Circular Std Book;
    color: ${colors.tertiary};
`;

export const SideContainer = styled.div`
    display: block;
    width: 25%;
    margin-left: 64px;

    @media (max-width: 1024px){
        display: none;
    }
`;

export const LinkToChatMobile = styled.div`
    display: none;


    @media (max-width: 1024px){
        display: flex;
        width: 100%;
        justify-content: flex-end;
        align-items: flex-start;
    }


`

export const LinkToChatContainer = styled.div`
    display: flex;
    justify-content: center;
    border-bottom: 5px solid ${colors.brownLight};
    margin-top: 48px;
    
    @media (max-width: 1024px){
        margin-top: 0px;
    }
`;

export const LinkToChatBallon = styled.div`
    height: min-content;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 18px;
    padding-bottom: 15px;
    padding-left: 11px;
    padding-right: 6px;
    background: ${colors.ballonBackground} 0% 0% no-repeat padding-box;
    box-shadow: 0px 8px 11px ${colors.ballonShadow};
    border-radius: 7px;
`;

export const BallonTriangle = styled.div`
    width: 0; 
    height: 0; 
    margin-top: 10%;
    margin-left: -2px;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    
    border-left: 10px solid ${colors.ballonBackground};
`

export const THead = styled.thead`
  background: ${colors.grayLight} 0% 0% no-repeat padding-box;
  height: 34px;
  opacity: 1;
`;

export const Th = styled.th`
  font-family: muli, sans-serif;
  font-weight: 800;
  font-style: normal;
  color: ${colors.grayDark};
  text-align: center;
  letter-spacing: 0px;
  opacity: 1;
  text-transform: uppercase;
`;

export const ThFilterable = styled.th`
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: muli, sans-serif;
  font-weight: 800;
  font-style: normal;
  color: ${colors.grayDark};
  text-align: center;
  letter-spacing: 0px;
  opacity: 1;
  text-transform: uppercase;
`

export const Td = styled.td`
  font-family: muli, sans-serif;
  font-weight: 300;
  font-size: normal;
  color: ${colors.blackLight};
  text-align: center;
  vertical-align: middle !important;
  letter-spacing: 0px;
  opacity: 1;
  text-transform: uppercase;
`;


export const LinkToChatTextRed = styled.div`
    font: normal normal 600 12px Muli;
    color: ${colors.textRed};
    text-decoration: none;
`;

export const LinkToChatTextBlack = styled.div`
    font: normal normal 300 11px Muli;
    color: ${colors.tertiary};
    text-decoration: none;
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  outline: none;
  border-radius: 0;
  padding: 12px;
  font-size: 1rem;
  width: 100%;
  height: 32px;
  font-weight: 600;
  border-radius: 6px;
  background: ${colors.primary};
  color: ${colors.white};
  transition: all.5s ease;

  -webkit-box-shadow: -4px 17px 50px -26px rgba(238, 168, 73, 1);
  -moz-box-shadow: -4px 17px 50px -26px rgba(238, 168, 73, 1);
  box-shadow: -4px 14px 50px -15px rgba(238, 168, 73, 1);

  
&:hover {
  background: ${colors.quaternary};
}

&:focus {
  background: ${colors.quaternary};
  outline:none !important;
}

`;

export const BankAccount = styled.div`
    width: 429px;
    padding-left: 0px;
    padding-right: 30px;
    @media (max-width: 600px){
        width: 100%;
        padding: 0px;
        margin-bottom: 15px;
    }
`

export const BankAccountContainer = styled.div`
    width: 100%;
    border-radius: 10px;
    padding: 23px 31px;
    margin-right: 30px;
    background-color: ${colors.grayLight};

    @media (max-width: 600px){
        margin-right: 0px;
    }
`;

export const BankAccountContainerHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 34px;
`;

export const BankAccountContainerHeaderTitle = styled.h3`
    font: normal normal normal 15px/21px Circular Std Book;
    color: ${(p: RadioButtonInterface) => p.isPrimary ? colors.primary : colors.grayDark};
    margin-bottom: 0px;
    margin-right: 19px;
`;

export const BankAccountContainerBody = styled.div`
    display: flex;
    padding-left: 6px;
`;

export const AccountTitle = styled.span`
    font: normal normal 600 10px/13px Muli;
    color: ${colors.grayDark};
`;

export const RadioButtonContainer = styled.div`
    display: flex;
    width: 18px;
    height: 18px;
    justify-content: center;
    align-items: center;
    border: 1px solid ${colors.primary};
    border-radius: 9px;
`;

export const RadioButtonContent = styled.div`
    width: 10px;
    height: 10px;
    border: 1px solid transparent;
    border-radius: 5px;
    background-color: ${(p: RadioButtonInterface) => p.isPrimary ? colors.primary : "transparent"};
`;

export const DataContainer = styled.div`
    margin-bottom: 15px;
`;

export const Info = styled.p`
    margin-bottom: 0px;
    font: normal normal bold 10px/13px Muli;
    color: ${colors.tertiary};
`;

export const SelectAnother = styled.div`
    display: flex;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
    font: normal normal 600 16px Muli;
    color: ${colors.primary};
    cursor: pointer;
`;

export const SelectBranchContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 64px;
    margin-bottom: -32px;
`;

export const SelectBranchText = styled.span`
    font-size: 14px;
    margin-right: 5px;
`

export const NavigationContainer = styled.ul`
    height: 36px;
    margin-top: 69px;
`;

export const TextContainer = styled.div`
    width: max-content;
`;

export const InfoContainer = styled.div`
    border-bottom: 1px solid #B8B4CC;
    margin-bottom: 24px;
`;